import { useContext } from 'react'
import { useMutation, useQuery } from 'react-query'
import { apiPost, apiGet, apiDelete, apiPatch } from 'api'
import AuthContext from 'context/auth-context'

const createScheduledEmail = async (token, dashboardId, params) => {
  const objectName = 'scheduled_email'
  const url = `dashboards/${dashboardId}/scheduled_emails`
  const response = await apiPost({ url, token, objectName, params })
  return response
}

export function useCreateScheduledEmail({ dashboardId, options }) {
  const token = useContext(AuthContext)

  return useMutation(
    (params) => createScheduledEmail(token, dashboardId, params),
    { ...options }
  )
}

const getScheduledEmails = async (token, dashboardId, params) => {
  const url = `dashboards/${dashboardId}/scheduled_emails`
  const data = await apiGet({ url, token, params })
  return data
}

export function useScheduledEmails({ dashboardId, params, options }) {
  const token = useContext(AuthContext)
  const queryFn = () => getScheduledEmails(token, dashboardId, params)
  const queryKey = ['scheduledEmails', dashboardId, params]

  return useQuery(queryKey, queryFn, { ...options })
}

const cancelScheduledEmail = async (token, id) => {
  const url = `scheduled_emails/${id}`
  const response = await apiDelete({ url, token })
  return response
}

export function useCancelScheduledEmail({ id, options }) {
  const token = useContext(AuthContext)

  return useMutation(() => cancelScheduledEmail(token, id), { ...options })
}

const updateScheduledEmail = async (token, id, params) => {
  const objectName = 'scheduled_email'
  const url = `scheduled_emails/${id}`
  const response = await apiPatch({ url, token, objectName, params })
  return response
}

export function useUpdateScheduledEmail({ id, options }) {
  const token = useContext(AuthContext)

  return useMutation((params) => updateScheduledEmail(token, id, params), { ...options })
}
